import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import * as planViewerTypes from '../plan-viewer/constants'

const initialState = fromJS({})

const topBarReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SORT_BY:
      return state.set('mobileTopBarSortBy', {
        sortBy: action.sortBy,
        direction: action.direction
      })
    case actionTypes.FILTER_BY:
      return state.set('mobileTopBarFilterBy', action.filterBy)
    case actionTypes.HIDE_ALL:
      return state.set('hideAll', action.hideAll)
    case planViewerTypes.CLEAR_PLAN_VIEWER:
      // We want the filter to reset when the plan viewer is closed
      return state.clear('mobileTopBarFilterBy').clear('mobileTopBarSortBy')
    default:
      return state
  }
}

export default topBarReducer
